module.exports = __webpack_public_path__ + "static/media/twelveth_miller_house10.35c466a1.jpg";